import { render } from "./TravelPassModal.vue?vue&type=template&id=72133f49&lang=pug"
import script from "./TravelPassModal.vue?vue&type=script&lang=ts"
export * from "./TravelPassModal.vue?vue&type=script&lang=ts"

import "./TravelPassModal.vue?vue&type=style&index=0&id=72133f49&lang=scss"
script.render = render

export default script